import { render, staticRenderFns } from "./ObjectCardRelated.vue?vue&type=template&id=fce163ea&scoped=true&"
import script from "./ObjectCardRelated.vue?vue&type=script&lang=js&"
export * from "./ObjectCardRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce163ea",
  null
  
)

export default component.exports